import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/SprayAssistBadge.css';
import SprayAssistIcon from '../../images/spray-assist/spray.svg';

const sprayBarConfig = {
  good: ['GoodActive', 'GoodActive', 'GoodActive'],
  moderate: ['ModerateActive', 'ModerateActive', 'ModerateInactive'],
  poor: ['PoorActive', 'PoorInactive', 'PoorInactive'],
};
const barKeys = ['first', 'second', 'third'];

function SprayAssistBadge({ sprayAssistValue }) {

  const badgeStatus = sprayAssistValue && sprayAssistValue !== 'NONE' ? sprayAssistValue.toLowerCase() : undefined;
  const config = sprayBarConfig[badgeStatus];

  // Spray Assist logic for NONE: No Spray Assist Badge required, returning placeholder
  if (!badgeStatus || !config) return <div
    className={styles.sprayAssistBadgePlaceholder}
    data-test-id="spray-placeholder" />;

  // Spray Assist logic for GOOD || MODERATE || POOR
  const badgeClass = badgeStatus ? styles[`sprayAssistBadge${badgeStatus.charAt(0).toUpperCase() + badgeStatus.slice(1)}`] : 'sprayAssistBadgeNone';
  const badgeTestId = badgeStatus ? `spray-badge-${badgeStatus}` : undefined;

  return (
    <div
      data-test-id={badgeTestId}
      className={`${styles.sprayAssistBadge} ${badgeClass}`}
    >
    <SprayAssistIcon />
    <div className={styles.sprayAssistProgress}>
      {config.map((type, idx) => (
        <div
          key={`${type}-${barKeys[idx]}`}
          data-test-id={`spray-progress-bar-${type}`}
          className={`${styles.sprayAssistProgressBar} ${styles[`sprayAssistProgress${type}`]}`}
        />
      ))}
    </div>
    </div>
  );
}

SprayAssistBadge.propTypes = {
  sprayAssistValue: PropTypes.string,
  'data-test-id': PropTypes.string,
};

export default SprayAssistBadge; 